import {useFormatCurrency} from 'platform/locale';

import {NL_BPM_ESTIMATE_CURRENCY} from '../constants/nlBpmTariff';

/**
 * BPM amounts are always whole euros. useFormatCurrency has a nullable
 * signature, but everything the calculation produces is a finite number.
 */
export function useBpmAmountFormatter() {
  const formatCurrency = useFormatCurrency();

  return (amount: number) => formatCurrency(amount, NL_BPM_ESTIMATE_CURRENCY, 0) ?? '';
}
